const Config = {
  apiPrefix: process.env.REACT_APP_API_PATH_PREFIX ?? "/api",
}

export default Config
